import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const SAFETY_SIGNAL_DETECTION_PROFILE_CODE: {
  SIGNAL_DETECTION_PROFILE_DUPLICATED_NAME: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_INVALID_NAME_MAX_LENGTH: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_INVALID_COMMENT_MAX_LENGTH: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_INVALID_TARGET_PRODUCTS_EMPTY: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_DUPLICATED_TARGET_PRODUCT: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_SCHEDULE_CONFIG_REQUIRED: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_INVALID_CRITERIA_DECIMAL_PLACES: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_INVALID_START_MONTH: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_INVALID_START_YEAR: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_INVALID_START_DATE_IN_PAST: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_DUPLICATED_SIGNAL_PREFIX: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_INVALID_SIGNAL_PREFIX: MvnCodeBE;
  SIGNAL_DETECTION_PROFILE_FIELD_NOT_EDITABLE_AFTER_EXECUTION: MvnCodeBE;
} = {
  SIGNAL_DETECTION_PROFILE_DUPLICATED_NAME: {
    status: 409,
    ko: "이미 동일한 이름의 프로파일이 존재합니다. 다른 이름을 입력해 주세요.",
    en: "A profile with this name already exists. Please enter a different name.",
  },
  SIGNAL_DETECTION_PROFILE_INVALID_NAME_MAX_LENGTH: {
    status: 400,
    ko: "프로파일명은 {length}자 이내로 입력해 주세요.",
    en: "Profile name must be {length} characters or less.",
  },
  SIGNAL_DETECTION_PROFILE_INVALID_COMMENT_MAX_LENGTH: {
    status: 400,
    ko: "최대 입력 글자수({length}자)를 초과했습니다.",
    en: "Maximum character limit ({length}) exceeded.",
  },
  SIGNAL_DETECTION_PROFILE_INVALID_TARGET_PRODUCTS_EMPTY: {
    status: 400,
    ko: "분석 대상 약물을 1개 이상 선택해 주세요.",
    en: "Please select at least one target product.",
  },
  SIGNAL_DETECTION_PROFILE_DUPLICATED_TARGET_PRODUCT: {
    status: 400,
    ko: "분석 대상 약물이 중복되었습니다. 중복 없이 선택해 주세요.",
    en: "Duplicate target products are not allowed. Please remove duplicates.",
  },
  SIGNAL_DETECTION_PROFILE_SCHEDULE_CONFIG_REQUIRED: {
    status: 400,
    ko: "정기 실행 프로파일에는 스케줄 설정이 필요합니다.",
    en: "Schedule configuration is required for scheduled frequencies.",
  },
  SIGNAL_DETECTION_PROFILE_INVALID_CRITERIA_DECIMAL_PLACES: {
    status: 400,
    ko: "기준값은 소수점 {maxDecimalPlaces}자리까지만 입력할 수 있습니다.",
    en: "Criteria values must have no more than {maxDecimalPlaces} decimal places.",
  },
  SIGNAL_DETECTION_PROFILE_INVALID_START_MONTH: {
    status: 400,
    ko: "시작 월은 1~12 중 하나를 선택해 주세요.",
    en: "Start month must be between 1 and 12.",
  },
  SIGNAL_DETECTION_PROFILE_INVALID_START_YEAR: {
    status: 400,
    ko: "시작 연도를 올바르게 입력해 주세요.",
    en: "Please enter a valid start year.",
  },
  SIGNAL_DETECTION_PROFILE_INVALID_START_DATE_IN_PAST: {
    status: 400,
    ko: "시작 시점은 현재 이후여야 합니다.",
    en: "Start date must not be in the past.",
  },
  SIGNAL_DETECTION_PROFILE_DUPLICATED_SIGNAL_PREFIX: {
    status: 409,
    ko: "이미 동일한 Signal Prefix가 존재합니다. 다른 값을 입력해 주세요.",
    en: "A profile with this signal prefix already exists. Please enter a different one.",
  },
  SIGNAL_DETECTION_PROFILE_INVALID_SIGNAL_PREFIX: {
    status: 400,
    ko: "Signal Prefix는 영문 대문자 또는 숫자 1~10자로 입력해 주세요.",
    en: "Signal prefix must be 1 to 10 uppercase letters or digits.",
  },
  SIGNAL_DETECTION_PROFILE_FIELD_NOT_EDITABLE_AFTER_EXECUTION: {
    status: 400,
    ko: "1회 이상 실행된 프로파일은 이름, 코멘트, 활성 상태만 수정할 수 있습니다.",
    en: "Only name, comment, and active status can be modified after the profile has been executed.",
  },
};

MvnCodeInitiate(SAFETY_SIGNAL_DETECTION_PROFILE_CODE);
